import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
const _hoisted_3 = { class: "text-h-primary-500" }
const _hoisted_4 = { class: "flex flex-col px-8" }
const _hoisted_5 = { class: "flex flex-col gap-4" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "flex flex-wrap gap-6 py-4" }
const _hoisted_8 = { class: "flex flex-col md:flex-row w-full gap-6" }
const _hoisted_9 = {
  class: "flex flex-col md:w-1/2 w-full",
  id: "activity-field"
}
const _hoisted_10 = { class: "flex flex-col gap-2 py-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "acitivity-title" }, /*#__PURE__*/_toDisplayString("Nome da Atividade*"), -1)
const _hoisted_12 = { class: "flex flex-col gap-2 py-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "description-input" }, /*#__PURE__*/_toDisplayString("Descrição da Atividade*"), -1)
const _hoisted_14 = { class: "ql-formats" }
const _hoisted_15 = { class: "ql-bold" }
const _hoisted_16 = { class: "ql-italic" }
const _hoisted_17 = { class: "ql-underline" }
const _hoisted_18 = {
  class: "ql-list",
  value: "bullet"
}
const _hoisted_19 = {
  class: "ql-link",
  value: "link"
}
const _hoisted_20 = {
  class: "flex flex-col md:w-1/2 w-full",
  id: "activity-term"
}
const _hoisted_21 = { class: "flex flex-wrap justify-between gap-2" }
const _hoisted_22 = { class: "flex flex-col col-span-2 row-start-3 gap-2 py-4 w-full lg:w-56" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, /*#__PURE__*/_toDisplayString("Data de Início"), -1)
const _hoisted_24 = { class: "flex flex-col col-span-2 row-start-3 gap-2 py-4 w-full lg:w-56" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, /*#__PURE__*/_toDisplayString("Data de Entrega*"), -1)
const _hoisted_26 = { class: "flex flex-col col-span-2 row-start-3 gap-2 py-4 w-full lg:w-56" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, /*#__PURE__*/_toDisplayString("Hora de Entrega*"), -1)
const _hoisted_28 = { class: "py-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, /*#__PURE__*/_toDisplayString("Anexar arquivo"), -1)
const _hoisted_30 = { class: "flex flex-wrap w-full gap-2 justify-between" }
const _hoisted_31 = { class: "flex flex-col gap-2 py-4 flex-1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, /*#__PURE__*/_toDisplayString("Nota Máxima*"), -1)
const _hoisted_33 = { class: "flex px-8 gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Dropzone = _resolveComponent("Dropzone")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Loader, {
      loader: _ctx.loading?.activities
    }, null, 8, ["loader"]),
    (!_ctx.loading?.activities || !_ctx.loading?.classes || !_ctx.loading?.courses)
      ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
          _createVNode(_component_Button, {
            class: "my-4 btn-simple flex gap-4",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("labels.generic", { en: "Activities", pt: "Atividades" })), 1)
            ]),
            _: 1
          }),
          _createElementVNode("form", {
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
            class: "py-4"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.activityId ? "Editar atividade" : "Criar atividade"), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_Dropdown, {
                      id: "list-courses",
                      class: "w-[320px]",
                      placeholder: 
                  _ctx.$t('labels.generic', {
                    pt: 'Selecionar Curso',
                    en: 'Select Course',
                  })
                ,
                      ref: "dropdownCourses",
                      emptyMessage: 
                  _ctx.$t('labels.generic', {
                    en: 'No courses relationed',
                    pt: 'Nenhum curso relacionado',
                  })
                ,
                      options: _ctx.listCourses,
                      optionLabel: "name",
                      optionValue: "id",
                      modelValue: _ctx.form.courseId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.courseId) = $event)),
                      onChange: _ctx.getAllClasses,
                      loading: _ctx.loading.courses,
                      showClear: true,
                      disabled: _ctx.loading.courses
                    }, null, 8, ["placeholder", "emptyMessage", "options", "modelValue", "onChange", "loading", "disabled"])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_Dropdown, {
                      id: "list-classes",
                      class: _normalizeClass(["w-[320px]", [{ 'p-invalid': _ctx.v$.classroomId.$error }]]),
                      placeholder: 
                  _ctx.$t('labels.generic', {
                    pt: 'Selecionar Turmas*',
                    en: 'Select CLasses*',
                  })
                ,
                      emptyMessage: 
                  _ctx.$t('labels.generic', {
                    en: 'No classes relationed',
                    pt: 'Nenhuma turma relacionada',
                  })
                ,
                      options: _ctx.listClasses,
                      optionLabel: "name",
                      optionValue: "id",
                      modelValue: _ctx.form.classroomId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.classroomId) = $event)),
                      ref: "dropdownClasses",
                      loading: _ctx.loading.classes,
                      disabled: !_ctx.form.courseId
                    }, null, 8, ["class", "placeholder", "emptyMessage", "options", "modelValue", "loading", "disabled"]),
                    _createVNode(_component_Errors, {
                      errors: _ctx.v$.classroomId.$errors
                    }, null, 8, ["errors"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_InputText, {
                      placeholder: 
                  _ctx.$t('labels.generic', {
                    en: 'Type activity name',
                    pt: 'Digite o nome da atividade',
                  })
                ,
                      modelValue: _ctx.form.title,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.title) = $event)),
                      class: _normalizeClass([{ 'p-invalid': _ctx.v$.title.$error }]),
                      id: "activity-title"
                    }, null, 8, ["placeholder", "modelValue", "class"]),
                    _createVNode(_component_Errors, {
                      errors: _ctx.v$.title.$errors
                    }, null, 8, ["errors"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", null, [
                      _createVNode(_component_Editor, {
                        id: "description-input",
                        modelValue: _ctx.form.description,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.description) = $event)),
                        class: _normalizeClass([{ 'p-invalid': _ctx.v$.description.$error }]),
                        editorStyle: "height: 230px"
                      }, {
                        toolbar: _withCtx(() => [
                          _createElementVNode("span", _hoisted_14, [
                            _withDirectives(_createElementVNode("button", _hoisted_15, null, 512), [
                              [
                                _directive_tooltip,
                                'Bold',
                                void 0,
                                { bottom: true }
                              ]
                            ]),
                            _withDirectives(_createElementVNode("button", _hoisted_16, null, 512), [
                              [
                                _directive_tooltip,
                                'Italic',
                                void 0,
                                { bottom: true }
                              ]
                            ]),
                            _withDirectives(_createElementVNode("button", _hoisted_17, null, 512), [
                              [
                                _directive_tooltip,
                                'Underline',
                                void 0,
                                { bottom: true }
                              ]
                            ]),
                            _withDirectives(_createElementVNode("button", _hoisted_18, null, 512), [
                              [
                                _directive_tooltip,
                                'Bullet List',
                                void 0,
                                { bottom: true }
                              ]
                            ]),
                            _withDirectives(_createElementVNode("button", _hoisted_19, null, 512), [
                              [
                                _directive_tooltip,
                                'Link',
                                void 0,
                                { bottom: true }
                              ]
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "class"])
                    ]),
                    _createVNode(_component_Errors, {
                      errors: _ctx.v$.description.$errors,
                      maxLength: 999,
                      actualLength: _ctx.form?.description?.length
                    }, null, 8, ["errors", "actualLength"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_Calendar, {
                        placeholder: "dd/mm/aaaa",
                        class: _normalizeClass([{ 'p-invalid': _ctx.v$.startDate.$error }]),
                        modelValue: _ctx.form.startDate as Date,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.startDate as Date) = $event)),
                        dateFormat: "dd/mm/yy",
                        minDate: _ctx.today
                      }, null, 8, ["class", "modelValue", "minDate"]),
                      _createVNode(_component_Errors, {
                        errors: _ctx.v$.startDate.$errors
                      }, null, 8, ["errors"])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_Calendar, {
                        placeholder: "dd/mm/aaaa",
                        class: _normalizeClass([{ 'p-invalid': _ctx.v$.finalDate.$error }]),
                        modelValue: _ctx.form.finalDate as Date,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.finalDate as Date) = $event)),
                        dateFormat: "dd/mm/yy",
                        minDate: _ctx.today
                      }, null, 8, ["class", "modelValue", "minDate"]),
                      _createVNode(_component_Errors, {
                        errors: _ctx.v$.finalDate.$errors
                      }, null, 8, ["errors"])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_component_InputMask, {
                        id: "final-hour",
                        placeholder: "00:00",
                        modelValue: _ctx.form.finalHour,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.finalHour) = $event)),
                        mask: "99:99",
                        class: _normalizeClass([{ 'p-invalid': _ctx.v$.finalHour.$error }])
                      }, null, 8, ["modelValue", "class"]),
                      _createVNode(_component_Errors, {
                        errors: _ctx.v$.finalHour.$errors
                      }, null, 8, ["errors"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode(_component_Dropzone, {
                      onFileSelected: _ctx.setFileActivities,
                      materials: _ctx.materials,
                      "onUpdate:materials": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.materials) = $event)),
                      onDismissedMaterial: _ctx.onDismissMaterial,
                      key: "dropzone"
                    }, null, 8, ["onFileSelected", "materials", "onDismissedMaterial"])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_InputNumber, {
                        placeholder: "Atribua um valor máximo",
                        min: 0,
                        modelValue: _ctx.form.scoreRange,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.scoreRange) = $event)),
                        class: _normalizeClass([{ 'p-invalid': _ctx.v$.scoreRange.$error }]),
                        mode: "decimal"
                      }, null, 8, ["modelValue", "class"]),
                      _createVNode(_component_Errors, {
                        errors: _ctx.v$.scoreRange.$errors
                      }, null, 8, ["errors"])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_Button, {
                class: "btn-outline",
                label: _ctx.$t('labels.generic', { en: 'Cancel', pt: 'Cancelar' }),
                onClick: _ctx.goBack
              }, null, 8, ["label", "onClick"]),
              _createVNode(_component_Button, {
                class: "btn-primary",
                label: _ctx.$t('labels.generic', { en: 'Save', pt: 'Salvar' }),
                type: "submit",
                loading: _ctx.loading.activities
              }, null, 8, ["label", "loading"])
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}